/**
 * Validates that a contributor note doesn't contain potentially dangerous characters.
 * Returns true if valid, false if contains < or > (potential XSS vectors).
 */
export const isValidContributorNote = (note: string | undefined): boolean => {
  if (!note) return true;
  return !/[<>]/.test(note);
};

/**
 * Sanitizes a contributor note by:
 * - Trimming leading/trailing whitespace
 * - Collapsing multiple consecutive spaces into single spaces
 * - Returning null if the result is empty
 *
 * Note: Does NOT remove characters - validation should happen before this.
 */
export const sanitizeContributorNote = (note: string): string | null => {
  if (!note) return null;

  const sanitized = note.trim().replace(/\s+/g, ' ');

  return sanitized.length > 0 ? sanitized : null;
};
